<template>
  <div class="borcliste" :style="'height:'+Height+'px' ">
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-input
      v-if="Liste"
      placeholder="Arama"
      prefix-icon="el-icon-search"
      v-model="search">
    </el-input>
    <ul v-if="Liste" :style="'height:'+(Height-75)+'px' ">
      <router-link
        v-for="Borc in Liste.filter(data => !search || data.AdSoyad.toLowerCase().includes(search.toLowerCase()))"
        :to="'/icra/dosya/'+Borc.Kisi_id" tag="li" active-class="Aktif">
        <div class="kisiBilgi">
          <span class="borcAd">{{Borc.AdSoyad}}</span>
          <span class="borcBina">{{Borc.Kat}} Kat {{Borc.kNo}} No<br><b>{{Borc.BinaAdi}}</b></span>
        </div>
        <div class="borcBilgi text-danger">
          <div style="width: 38%"><b>Dosya Sayısı</b> {{Borc.IcraDosya}}</div>
          <div style="width: 60%" class="text-right"><b>Gecikmiş Borç</b> {{Borc.IcraOdenecek}} TL</div>
        </div>
      </router-link>

    </ul>
  </div>
</template>

<script>
  import Yukleniyor from "../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    props: ["Yenile"],
    data() {
      return {
        lo: false,
        Kisi_id: null,
        SayfaAdi: 'İcralık Listesi',
        SeciliBina: null,
        Liste: null,
        search: '',
        Height: window.innerHeight - 150,
      }
    },
    methods: {

      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'icra/dosya/liste/' + this.SeciliBina})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Liste = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    },
    created() {

      if (this.$store.getters.BinaBilgi) {
        this.SeciliBina = this.$store.getters.BinaBilgi.id;
      }
      this.SayfaYukle();
    },
    computed: {
      rSAyfaYukle() {
        return this.Yenile
      },
    },
    watch: {
      rSAyfaYukle() {
        if (this.Yenile) this.SayfaYukle();
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Icra/IcraListe.vue